import * as React from 'react';

type UsePrefetchAdjacentImagesParams = {
    open: boolean;
    onPrefetch: ((imageId: number) => void) | undefined;
    previousImageId: number | null;
    nextImageId: number | null;
};

export function usePrefetchAdjacentImages({
    open,
    onPrefetch,
    previousImageId,
    nextImageId
}: UsePrefetchAdjacentImagesParams) {
    React.useEffect(
        function prefetchAdjacentImages() {
            if (!open || !onPrefetch) {
                return;
            }

            if (previousImageId !== null) {
                onPrefetch(previousImageId);
            }

            if (nextImageId !== null) {
                onPrefetch(nextImageId);
            }
        },
        [open, onPrefetch, previousImageId, nextImageId]
    );
}
